import { render, staticRenderFns } from "./capital_curve.vue?vue&type=template&id=226badbe&scoped=true&"
import script from "./capital_curve.vue?vue&type=script&lang=js&"
export * from "./capital_curve.vue?vue&type=script&lang=js&"
import style0 from "./capital_curve.vue?vue&type=style&index=0&id=226badbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226badbe",
  null
  
)

export default component.exports